/**
 *
 * Pficon
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import 'fonts/icomoon/style.css';

const PfLoader = ({ className = '', color = '#8F98A9' }) => {
  const lineStyle = { borderColor: color };
  return (
    <div className={`pf-line-loader ${className}`}>
      <div className="pf-line-loader-inner one" style={lineStyle} />
      <div className="pf-line-loader-inner two" style={lineStyle} />
      <div className="pf-line-loader-inner three" style={lineStyle} />
    </div>
  );
};

PfLoader.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default PfLoader;
